<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 style="font-size:24px!important" class="card-title mx-2">ENQUIRIES LIST</h4>
        </div>
      </div>
      <h5>*Select the options to filter the results</h5>
      <div class="row">
        <!-- <div class="flex md3 offset-md-3 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter" v-model="usertype">
              <option value selected disabled hidden>User Type</option>
              <option value="user">User</option>
              <option value="guest">Guest</option>
            </select>
          </div>
        </div>-->
        <div class="flex md4 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="status">
              <option value selected disabled hidden>Status</option>
              <option value=" ">All</option>
              <option value="read">Read</option>
              <option value="unread">Unread</option>
              <option value="replied">Replied</option>
            </select>
          </div>
        </div>
      </div>
      <div class="flex md12 sm6 xs12 overflow-auto">
        <div class="overflow-aut0" style="overflow:auto">
          <b-table
            hover
            v-if="data.length"
            class="table-sm th table-sm td"
            id="my-table"
            :fields="fields"
            :items="data"
            small
            borderless
            head-variant="dark"
            table-variant="light"
          >
          <template v-slot:cell(sno)="data">
              <span v-if="currentPage > 1">{{
                (currentPage - 1) * perPage + data.item.sno
              }}</span>
              <span v-else>{{ data.item.sno }}</span>
            </template>
            <template v-slot:cell(_id)="data">
              <router-link :to="'/enquiryview/'+data.item._id ">
                <b-button variant="success">View Details</b-button>
              </router-link>
            </template>
              <template v-slot:cell(status)="data">
              <span v-if="data.item.status=='read'" style="color:blue;">read</span>
              <span v-if="data.item.status=='unread'" style="color:red;">unread</span>
              <span v-if="data.item.status=='replied'" style="color:green;">replied</span>
            </template>
          </b-table>
          <p v-else>No Data Found</p>
          <br />
          <b-pagination
            align="center"
            v-model="currentPage"
           :total-rows="totalData"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            @change="nextPage"
            aria-controls="my-table"
          ></b-pagination>
          <br />
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  data () {
    return {
      id1: '',
      msg: '',
      visible: false,
       perPage: 20,
      currentPage: 1,
      dat: [],
      fields: [
        // {
        //   key: "slno",
        //   label: "Sl No."
        // },
         {
          key: "sno",
          label: "S.No",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: 'uid.fullName',
          label: 'User Name',
          sortable: false,
          tdClass: ' cnt  text-capitalize',
          thClass: ' pdngtblcol1 cnt',
        },
        {
          key: 'species.commonName',
          label: 'Species',
          sortable: false,
        },
        {
          key: 'status',
          sortable: false,
          tdClass: 'pdngtblcol',
          // thClass:"pdngtblhead"
        },
        {
          key: 'enquiryDate',
          label: 'Submitted Date',
          sortable: false,
          //  thClass:"pdngtblhead"
        },
        {
          label: 'Action ',
          key: '_id',
          sortable: false,
          //  thClass:"pdngtblhead",
          tdClass: 'tblbutton',
        },
      ],
      data: [],
      data1: [],
      usertype: '',
      status: '',
      stat: '',
      totalData: "",
    }
  },

  mounted: function () {
    this.getList()
  },
  computed: {
    rows () {
      return this.data.length
    },
  },
  watch: {
    status: function () {
      this.getList()
    },
    usertype: function () {
      this.getList()
    },
    
  },

  methods: {
      nextPage(ev) {
      this.currentPage = ev;
      this.getList();
    },
    getList () {
      this.visible = true
      var data1 = {}
      //   if (this.usertype !== '') { data1['usertype'] = this.usertype }
      if (this.status !== '') {
        data1['status'] = this.status
      }
        data1["page"] = this.currentPage;
      data1["limit"] = this.perPage;
      axios({
        method: 'POST',
        url: '/enquiry/all/list',
        data: data1,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then(response => {
          if (response.data.status === true) {
             for (var i = 0; i < response.data.data.length; i++) {
            response.data.data[i].sno = i + 1;
          }
            this.data = response.data.data
            this.totalData = response.data.totalLength;

            for (var i = 0; i < this.data.length; i++) {
              var count = i + 1
              var dt = this.data[i].enquiryDate
              dt = new Date(dt)
              dt = dt.toString()
              dt = dt.slice(0, 15)
              this.data[i].enquiryDate = dt
              this.data[i].slno = count
            }
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch(e => {
          console.log(e)
          this.visible = false
          // this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>
<style scoped>
.pdngtblcol {
  padding-right: 50px !important;
}
.pdngtblcol1 {
  padding-left: 30px !important;
}

.pdngtblhead {
  padding-top: 30px !important;
  margin-top: 30px !important;
  padding-bottom: 30px !important;
}
.thead-dark {
  padding-top: 80px !important;
}
.table-sm th,
.table-sm td {
  padding: 30px !important;
}
.filter {
  width: 100% !important;
}
.tblbutton {
  text-align: right !important;
  width: 30% !important;
}
</style>
